import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { QuestionsService } from "../../services/questions.service";
import { Location } from "@angular/common";
import { FlashService } from "../../flash/flash.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ErrorService } from "../../services/error.service";

@Component({
  selector: "app-questionsedit",
  templateUrl: "./edit.component.html",
  styleUrls: ["./edit.component.css"],
})
export class QuestionseditComponent implements OnInit {
  constructor(
    private questionService: QuestionsService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService
  ) {}

  question;
  questionId;
  errors;
  categ_data:any;
  options: boolean = true;
  option_data: Array<any> = [];

  questionForm = new FormGroup({
    name: new FormControl("", Validators.required),
    category: new FormControl("", Validators.required),
    type: new FormControl("", Validators.required),
  });

  tags: any[] = [];

  changeEvent(e) {
    if (e.target.value === "dropdown" || e.target.value === "radio" || e.target.value === "checkbox") {
      this.options = true;
    } else {
      return (this.options = false);
    }
  }

  change(type) {
    if (type === "dropdown" || type === "radio"|| type === "checkbox") {
      this.options = true;
    } else {
      return (this.options = false);
    }
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.questionId = params["id"];
    });

    this.get_category_data();

    this.questionService.getQuestion(this.questionId).subscribe(
      (data: any) => {
        const type = data.body.questionDetail.type
          ? data.body.questionDetail.type
          : null;
        const option = data.body.questionDetail.options
          ? data.body.questionDetail.options
          : null;

        this.questionForm.patchValue({
          name: data.body.questionDetail.name
            ? data.body.questionDetail.name
            : null,
          category: data.body.questionDetail.category
            ? data.body.questionDetail.category
            : null,
          type: type,
          options: option.map((e) => {
            this.tags.push({ name: e });
          }),
        });

        if (type) {
          this.change(type);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  locationBack() {
    this.location.back();
  }

  onSubmit() {
    this.option_data = [];

    if (
      this.questionForm.value.type === "dropdown" ||
      this.questionForm.value.type === "radio" || this.questionForm.value.type === "checkbox"
    ) {
      this.tags.forEach((item) => {
        this.option_data.push(item.name);
      });
    }

    this.questionForm.value.options = this.option_data;

    //remove dot in question name
    this.questionForm.value.name = this.questionForm.value.name.split('.').join("");

    this.spinnerService.show();

    this.questionService
      .updateQuestion(this.questionId, this.questionForm.value)
      .subscribe(
        (data) => {
          this.spinnerService.hide();

          if (data.body["success"]) {
            this.flashService.show(data.body["message"], "alert-success");
            this.router.navigateByUrl("questions/list");
          } else {
            this.errors = data.body["message"];
            this.flashService.show(data.body["message"], "alert-danger");
          }
        },
        (error) => {
          this.spinnerService.hide();
          this.errorService.errorHandling(error);
        }
      );
  }

  onTagRemoved(tag: any) {
    const index = this.tags.findIndex(
      (t) => t.name.toLowerCase() === tag.name.toLowerCase()
    );
    if (index !== -1) {
      this.tags = [...this.tags.slice(0, index), ...this.tags.slice(index + 1)];
    }
  }

  onTagAdded(tag: any) {
    const index = this.tags.findIndex(
      (t) => t.name.toLowerCase() === tag.name.toLowerCase()
    );
    if (index === -1) {
      this.tags = [...this.tags, tag];
    }
  }

  get_category_data(){
    this.questionService.getQuestionsCategoryDd().subscribe(
      (data) => {
        this.spinnerService.hide();
        this.categ_data = data.body
        console.log(this.categ_data.category);
        
        
      },
      (error) => {
        console.log(error);
        
        this.spinnerService.hide();
        this.errorService.errorHandling(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/questions/edit/edit.component.ts